var swiper = new Swiper(".secondarySlider", {
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    pagination: {
        el: ".swiper-pagination-2",
        clickable: true
    },
});